module.exports = __webpack_public_path__ + "static/img/banner.415c0287.jpg";